import { render, staticRenderFns } from "./ArticleLegend.vue?vue&type=template&id=72c89cd2&scoped=true&"
import script from "./ArticleLegend.vue?vue&type=script&lang=js&"
export * from "./ArticleLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c89cd2",
  null
  
)

export default component.exports